module.exports = __webpack_public_path__ + "img/zhu_xc12.97f570f3.jpg";